import { ALL_DAY_ALERT_CHOICES, TIMED_ALERT_CHOICES, alertLabel } from "@nmt/shared";
import { cx } from "./ui";

/** Alert times as chips to tick (up to 5, as Google allows); none ticked: no alerts. */
export function AlertPicker({ value, onChange, allDay, disabled }: { value: number[]; onChange: (v: number[]) => void; allDay: boolean; disabled?: boolean }) {
  const choices = [...new Set([...(allDay ? ALL_DAY_ALERT_CHOICES : TIMED_ALERT_CHOICES), ...value])].sort((a, b) => a - b);
  return (
    <div className="flex flex-wrap gap-1.5">
      {choices.map((m) => {
        const on = value.includes(m);
        return (
          <button
            key={m}
            type="button"
            disabled={disabled || (!on && value.length >= 5)}
            aria-pressed={on}
            onClick={() => onChange(on ? value.filter((x) => x !== m) : [...value, m].sort((a, b) => b - a))}
            className={cx("rounded-full border px-3 py-1 text-xs font-semibold disabled:opacity-40", on ? "border-brand bg-brand text-white" : "border-line bg-white text-ink-soft hover:text-ink")}
          >
            {alertLabel(m, allDay)}
          </button>
        );
      })}
    </div>
  );
}

/** "1 day before, 1 hour before" (or "None"). */
export const alertsText = (v: number[], allDay: boolean) => (v.length ? [...v].sort((a, b) => b - a).map((m) => alertLabel(m, allDay)).join(", ") : "None");
